import { Button, Paper, styled, Typography } from '@mui/material';
import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import Home from '../../home/Home';
import CustodianBill from '../SperatedBillgen/CustodianBill';
import Airline from './Airline';
import CoustomBill from './CoustomBill';
import DoCharges from './DoCharges';
import DocumentetionBill from './DocumentetionBill';
import GovttStaff from './GovttStaff';
import ServiceProvider from './ServiceProvider';
import Shippline from './Shippline';
import ThirdParty from './ThirdParty';
import Transporter from './Transporter';


const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
function SepratedBill() {
    const [key ,setKey] = useState('custodian')
    const tabsselect = (k) => {
    setKey(k)
    if(k==='alliedagency'||k==='airlines'||'other'){
      setThirdparty(true);
        setDocumnet(true);
      setopen(false);
    }else{
      setThirdparty(true);
      setDocumnet(true);
    setopen(true);
    }
    }
    const [Thirdparty,setThirdparty]=useState(true);
    const [Documnet,setDocumnet]=useState(true);
    const [open,setopen]=useState(false);
    const openThirdparty=()=>{
        setThirdparty(false);
        setDocumnet(true);
        setopen(true);
    }
    const openDocument=()=>{
        setThirdparty(true);
        setDocumnet(false);
        setopen(true);
    }

  return (
    <div>
       <Home />
        <div style={{paddingLeft:'100px'}}>
        <Tabs activeKey={key} onSelect={tabsselect} className="bg-light">
        <Tab eventKey="custodian" title="CustodianPayment">
            <CustodianBill />
        </Tab>
        <Tab eventKey="custom" title="Cust_Payment">
            <CoustomBill />
        </Tab>
        <Tab eventKey="alliedagency" title="AllideAgencyPayment" >
        <div hidden={open} style={{alignItems:'center'}}>
            <ItemPap>
            <Typography>Allied Agency Payment</Typography>
            <Button variant='contained' size='small' onClick={openThirdparty}>Third Party Payment</Button>{' '}
            <Button variant='contained' size='small' onClick={openDocument}>Documentation Payment</Button>{' '}
            </ItemPap>
        </div>
        <div hidden={Thirdparty}>
            <ThirdParty />
        </div>
        <div hidden={Documnet}>
            <DocumentetionBill />
        </div>
        </Tab>
        <Tab eventKey="airlines" title="Air/Shipp Payment">
        <div hidden={open} style={{alignItems:'center'}}>
            <ItemPap>
            <Typography>AirLine/SippingLine Payment</Typography>
            <Button variant='contained' size='small' onClick={openThirdparty}>AirLines Payment</Button>{' '}
            <Button variant='contained' size='small' onClick={openDocument}>ShippingLine Payment</Button>{' '}
            </ItemPap>
        </div>
        <div hidden={Thirdparty}>
        <Airline />
        </div>
        <div hidden={Documnet}>
          <Shippline />
        </div>
        </Tab>
        <Tab eventKey="docharges" title="DoCharges">
    <DoCharges />
        </Tab>
        <Tab eventKey="transportation" title="Transport Payment">
        <Transporter />
        </Tab>
        <Tab eventKey="other" title="Other Payment">
        <div hidden={open} style={{alignItems:'center'}}>
            <ItemPap>
            <Typography>Other Payment</Typography>
            <Button variant='contained' size='small' onClick={openThirdparty}>Govtt Staff Payment</Button>{' '}
            <Button variant='contained' size='small' onClick={openDocument}>Service Provider Payment</Button>{' '}
            </ItemPap>
        </div>
        <div hidden={Thirdparty}>
        <GovttStaff />
        </div>
        <div hidden={Documnet}>
          <ServiceProvider />
        </div>
        </Tab>
        </Tabs>
    </div>
    </div>
  )
}

export default SepratedBill